<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "BaseAmdmin",
};
</script>

<style></style>
